/* 
https://developers.google.com/photos/picker/reference/rest
/* 
/* 
/* 
*/
import axios, { AxiosError, AxiosInstance } from 'axios';
import { LocalStore } from 'constants/localstore';
import { MAX_TOKEN_TIME } from './google.params';

export interface Session {
  id: string;
  mediaItemsSet: boolean;
  pickerUri: Url;
  pollingConfig: PollingConfig;
  expireTime: string;
}

interface PollingConfig {
  pollInterval: string;
  timeoutIn: string;
}

interface SessionData {
  mediaItems: GoogleMediaItem[];
  nextPageToken: string;
}

interface MediaFile {
  baseUrl: string;
  mimeType: string;
  filename: string;
  mediaFileMetadata: object;
}

export interface GoogleMediaItem {
  id: string;
  createTime: string;
  type: 'TYPE_UNSPECIFIED' | 'PHOTO' | 'VIDEO';
  mediaFile: MediaFile;
}

export type GoogleApiError = AxiosError | '401' | '403';

let _instance: AxiosInstance | null = null;

const _apiCall = <T>(api: AxiosInstance, cb: (api: AxiosInstance) => Promise<T>) => {
  const tokenDate = localStorage.getItem(LocalStore.googleOAuthDate);
  if (!tokenDate) throw '401';
  if (Date.now() - Number(tokenDate) > MAX_TOKEN_TIME) throw '403';
  return cb(api).catch((err) => {
    if ((err as AxiosError).response?.status === 401) {
      _instance = null;
      throw '401';
    }
    throw err;
  });
};

const _apiInit = async <T>(cb: (api: AxiosInstance) => Promise<T>) => {
  if (_instance) return _apiCall(_instance, cb);
  const token = localStorage.getItem(LocalStore.googleOAuth);
  if (!token) throw '401';
  _instance = axios.create({
    baseURL: import.meta.env.VITE_DOMAIN_GOOGLE_PICKER,
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  });
  return _apiCall(_instance, cb);
};

/* *** */

export const createSession = () => {
  return _apiInit<Session>(async (api: AxiosInstance) => {
    const res = await api.post('/sessions');
    return res.data;
  });
};

export const deleteSession = async (id: string) => {
  return _apiInit(async (api: AxiosInstance) => {
    const res = await api.delete(`/sessions/${id}`);
    return res.data;
  });
};

export const getSession = async (id: string) => {
  return _apiInit<Session>(async (api: AxiosInstance) => {
    const res = await api.get(`/sessions/${id}`);
    return res.data;
  });
};

export const getSessionData = async (id: string) => {
  return _apiInit<SessionData>(async (api: AxiosInstance) => {
    const res = await api.get(`/mediaItems?sessionId=${id}`);
    return res.data;
  });
};
